<template>
	<div style="background-color: #fff;padding: 20px;" class="container-top">
		<!-- 右上角 返回按钮 -->
		<div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:30px;">
			<div style="font-size:18px;color:#333333;line-height:18px;font-weight:500;">举报信息</div>
			<a-button @click="goBack" style="float:none;">
				<a-icon type="left" /> 返回列表
			</a-button>
		</div>
		<a-descriptions :column="1" bordered style="flex: 1;">
			<a-descriptions-item label="举报单号">
				{{detailModel.reportNo}}
			</a-descriptions-item>
			<a-descriptions-item label="举报人">
				{{detailModel.reporterUserName }}
				<span  style="margin-left:8px;color:#999;font-size:13px;">
					（已举报{{ detailModel.reporterTotalCount }}次
					有效举报{{ detailModel.reporterValidCount }}；
					恶意举报{{ detailModel.reporterMaliciousCount }}
					无效举报{{ detailModel.reporterInvalidCount }}）
				</span>
			</a-descriptions-item>

			<a-descriptions-item label="举报时间">
				{{detailModel.createTime}}
			</a-descriptions-item>
			<a-descriptions-item label="举报对象">
				{{detailModel.targetUserName}}
			</a-descriptions-item>


			<a-descriptions-item label="举报原因">
				{{detailModel.reportReason}}
			</a-descriptions-item>
			<a-descriptions-item label="举报内容">
				<div style="display:flex;align-items:flex-start;gap:4px;">
					<div>{{ detailModel.reportContent }}</div>
					<a-button type="link" size="small" @click="openCommentDetail" v-if="detailModel.commentId != null && detailModel.commentId !== ''" style="white-space:nowrap;flex-shrink:0;">查看详情 →</a-button>
				</div>
				<div v-if="detailModel.reportContentIImage" v-viewer style="display:flex;gap:8px;flex-wrap:wrap;margin-top:8px;">
					<img v-for="(img,i) in detailModel.reportContentIImage.replace(/,/g, ';').split(';').filter(u=>u)" :key="i" :src="img"
						style="width:80px;height:80px;object-fit:cover;border:1px solid #eee;cursor:pointer;border-radius:4px;" />
				</div>
			</a-descriptions-item>
			<a-descriptions-item label="举报描述">
				<div>{{ detailModel.reportDesc }}</div>
			</a-descriptions-item>
			<a-descriptions-item label="图片证据">
				<div v-if="detailModel.reportImages" v-viewer style="display:flex;gap:8px;flex-wrap:wrap;">
					<img v-for="(img,i) in detailModel.reportImages.replace(/,/g, ';').split(';').filter(u=>u)" :key="i" :src="img"
						style="width:80px;height:80px;object-fit:cover;border:1px solid #eee;cursor:pointer;border-radius:4px;" />
				</div>
				<span v-else style="color:#999;">暂无图片</span>
			</a-descriptions-item>
		</a-descriptions>
		<div class="titleCz">举报处理</div>
		<a-descriptions :column="1" bordered style="flex: 1;">
			<a-descriptions-item label="处理方式">
				<span style="margin-right:10px">{{ detailModel.targetType === 'REPLY' ? '是否对留言屏蔽处理' : '是否对评价屏蔽处理' }}</span>
				<a-radio-group v-model="detailModel.handleAction" @change="onChange" >
					<a-radio :value="true">
						是
					</a-radio>
					<a-radio :value="false">
						否
					</a-radio>
				</a-radio-group>
			</a-descriptions-item>
			<a-descriptions-item :label="`回复举报人（${ detailModel.isMsgToReporter == 'SENT' ? '已发送' : '未发送'}）`">
				<a-select @change="hhChange1" style="width: 200px" class="mr12" placeholder="选择话术" show-search option-filter-prop="name" :filter-option="filterOption" :disabled="detailModel.isMsgToReporter == 'SENT'">
					<a-select-option v-for="(item, index) of hhData1" :key="index" :value="item.templateId">
						{{ item.templateContent }}
					</a-select-option>
				</a-select>
				<a-textarea style="margin-top:10px" placeholder="输入回复内容" v-model="detailModel.msgToReporterContent" :disabled="detailModel.isMsgToReporter == 'SENT'" />
				<div style="margin-top:20px">
					<a-button @click="send(1)" :disabled="detailModel.isMsgToReporter == 'SENT' || !(detailModel.msgToReporterContent || '').trim()" :loading="sendReporterLoading" type="primary">发送</a-button>
				</div>
			</a-descriptions-item>

			<a-descriptions-item :label="`回复被举报人（${ detailModel.isMsgToTarget == 'SENT' ? '已发送' : '未发送'}）`">
				<a-select @change="hhChange2" style="width: 200px" class="mr12" placeholder="选择话术" show-search option-filter-prop="name" :filter-option="filterOption" :disabled="detailModel.isMsgToTarget == 'SENT'">
					<a-select-option v-for="(item, index) of hhData2" :key="index" :value="item.templateId">
						{{ item.templateContent }}
					</a-select-option>
				</a-select>
				<a-textarea style="margin-top:10px" placeholder="输入回复内容" v-model="detailModel.msgToTargetContent" :disabled="detailModel.isMsgToTarget == 'SENT'" />
				<div style="margin-top:20px">
					<a-button @click="send(0)" :disabled="detailModel.isMsgToTarget == 'SENT' || !(detailModel.msgToTargetContent || '').trim()" :loading="sendTargetLoading" type="primary">发送</a-button>
				</div>
			</a-descriptions-item>

			<a-descriptions-item label="处理结果">
				<a-select style="width: 200px" v-model="detailModel.handleResult" class="mr12" placeholder="请选择处理结果"
					show-search option-filter-prop="name" :filter-option="filterOption">
					<a-select-option v-for="(item, index) of tags1" :key="index" :value="item.tagId">
						{{ item.tagName }}
					</a-select-option>
				</a-select>
			</a-descriptions-item>

			<a-descriptions-item label="举报状态">
				<a-select style="width: 200px" v-model="detailModel.reportStatus" class="mr12" placeholder="请选择举报状态"
					show-search option-filter-prop="name" :filter-option="filterOption">
					<a-select-option v-for="(item, index) of tags2" :key="index" :value="item.tagId">
						{{ item.tagName }}
					</a-select-option>
				</a-select>
			</a-descriptions-item>

			<a-descriptions-item label="备注">
				<a-textarea placeholder="输入备注内容（后台查看不同步前端）" v-model="detailModel.handleRemark" />
			</a-descriptions-item>
		</a-descriptions>
		<div style="height: 40px;"></div>
		<a-button @click="sureEdit" type="primary" >保存</a-button>
		<div style="height: 40px;"></div>
		<div class="titleCz">操作日志</div>
		<a-table :columns="columns" :data-source="tableData" :pagination="pageInfo" @change="changePage"
			:loading="loading">
		</a-table>

		<a-modal title="留言及回复" :visible="replyModal" width="1000px" :footer="null" @cancel="replyModal = false">
			<div v-if="currentComment">
				<!-- 原评价 -->
				<div style="padding:12px;background:#f5f5f5;border-radius:6px;margin-bottom:16px;">
					<div style="display:flex;align-items:center;margin-bottom:8px;">
						<div v-viewer style="display:inline-block;cursor:pointer;flex-shrink:0;margin-right:8px;">
							<img v-if="currentComment.avatar" :src="currentComment.avatar"
								 style="width:36px;height:36px;border-radius:50%;object-fit:cover;"/>
						</div>
						<span style="font-weight:500;">{{currentComment.nickname}}</span>
						<a-tag v-if="currentComment.tagName" color="#2CBD9C" style="margin-left: 6px;">
							{{currentComment.tagName}}
						</a-tag>
						<a-tag v-if="currentComment.pinStatus" color="#1890ff" style="margin-left:6px;">置顶</a-tag>
						<a-tag v-if="currentComment.blackStatus" color="black" style="margin-left:6px;">黑名单</a-tag>
						<a-tag v-if="currentComment.hiddenStatus" color="#faad14" style="margin-left:6px;">屏蔽</a-tag>
						<span v-if="currentComment.score" style="display:inline-flex;align-items:center;margin-left:6px;vertical-align:middle;">
                                <a-rate :value="currentComment.score" disabled allow-half style="font-size:14px;"/>
                                <span style="margin-left:4px;font-size:13px;color:#666;">{{ currentComment.score }}</span>
                                <a-button type="link" size="small" @click="showScoreDetail(currentComment)" style="font-size:18px;line-height:1;padding:0 4px;min-width:auto;">⋮</a-button>
                            </span>
					</div>
					<div style="padding-left:44px;font-size:14px;color:#333;margin-bottom:6px;">{{currentComment.comment}}</div>
					<div v-viewer style="padding-left:44px;margin-bottom:6px;">
						<img v-for="(img,i) in (currentComment.commentImages||'').split(/[,;]/).filter(u=>u)" :key="i" :src="img" style="width:80px;height:80px;object-fit:cover;border:1px solid #eee;cursor:pointer;margin-right:6px;" />
					</div>
					<div style="padding-left:44px;font-size:12px;color:#999;">{{currentComment.publicTime}}</div>
					<!-- 统计操作栏 -->
					<div style="display:flex;align-items:center;justify-content:space-between;padding-left:44px;margin-top:6px;">
						<div></div>
						<div style="display:flex;align-items:center;gap:12px;">
							<span style="color:#999;"><a-icon type="eye"/> {{currentComment.viewNum || 0}}</span>
							<span style="cursor:pointer;color:#999;"><a-icon type="like"/> {{(currentComment.likeNum || 0) + (currentComment.virtualLikeNum || 0)}}</span>
							<span style="cursor:pointer;color:#999;"><a-icon type="message"/> {{currentComment.commentNum || 0}}</span>
						</div>
					</div>
				</div>
				<div v-if="replyDetailList && replyDetailList.length" style="padding-left:44px;">
					<div v-for="(item, idx) in replyDetailList" :key="item.replyId || idx"
						 :style="item.isTargetReply ? 'background:#fff7e6;border:1px solid #ffa940;border-radius:6px;padding:8px;margin-top:10px;border-bottom:1px solid #ffd591;padding-bottom:8px;' : 'margin-top:10px;border-bottom:1px solid #f7f7f7;padding-bottom:8px;'">
						<!-- 头像、昵称、标签 -->
						<div style="display:flex;align-items:center;">
							<div v-viewer style="width:36px;height:36px;border-radius:18px;border:2px solid #f7f7f7;overflow:hidden;flex-shrink:0;cursor:pointer;">
								<img style="width:36px;height:36px;border-radius:18px;object-fit:cover;"
									 v-if="item.replyAvatar" :src="item.replyAvatar" alt=""/>
							</div>
							<div style="margin-left:8px;">
								{{item.replyName || '匿名'}}
								<a-tag v-if="item.isTargetReply" color="#fa8c16" style="margin-left:6px;">目标回复</a-tag>
								<a-tag v-if="item.pinStatus" color="#1890ff" style="margin-left:6px;">置顶</a-tag>
								<a-tag v-if="item.blackStatus" color="black" style="margin-left:6px;">黑名单</a-tag>
								<a-tag v-if="item.hiddenStatus" color="#faad14" style="margin-left:6px;">屏蔽</a-tag>
							</div>
						</div>
						<!-- 回复内容 -->
						<div style="padding-left:44px;"><span v-if="item.targetName" >@{{item.targetName}}：</span>{{item.replyContent}}</div>
						<!-- 回复图片 -->
						<div v-if="item.replyImgArr && item.replyImgArr.length" v-viewer
							 style="display:flex;gap:8px;margin-top:8px;flex-wrap:wrap;padding-left:44px;">
							<img v-for="(imgUrl, i) in item.replyImgArr" :key="i" :src="imgUrl"
								 style="width:80px;height:80px;object-fit:cover;border:1px solid #eee;cursor:pointer;"
								 alt=""/>
						</div>
						<!-- 底部栏：时间、统计、操作 -->
						<div style="display:flex;align-items:center;justify-content:space-between;padding-left:44px;">
							<div style="font-size:12px;color:#999;">{{item.replyTime || ''}}</div>
							<div style="display:flex;align-items:center;gap:12px;">
								<span style="cursor:pointer;color:#999;" ><a-icon type="like"/> {{(item.likeNum || 0) + (item.virtualLikeNum || 0)}}</span>
								<span style="cursor:pointer;color:#999;"><a-icon type="message"/> {{item.commentNum || 0}}</span>

							</div>
						</div>
						<!-- 嵌套回复 (replay) -->
						<div v-if="item.replay && item.replay.length" style="padding-left:44px;margin-top:6px;">
							<div v-for="(rp, ri) in item.replay" :key="ri" v-if="rp"
								 :style="rp.isTargetReply ? 'background:#fff7e6;border:1px solid #ffa940;border-radius:4px;padding:4px 8px;margin-bottom:6px;' : 'background:#f7f7f7;padding:4px 8px;border-radius:4px;margin-bottom:6px;'">
								<div style="display:flex;align-items:center;">
									<div v-viewer style="display:inline-block;cursor:pointer;flex-shrink:0;">
										<img v-if="rp.replyAvatar" :src="rp.replyAvatar"
											 style="width:24px;height:24px;border-radius:12px;object-fit:cover;" alt=""/>
									</div>
									<span style="margin-left:6px;font-weight:500;font-size:13px;">{{rp.replyName || '匿名'}}</span>
									<a-tag v-if="rp.isTargetReply" color="#fa8c16" style="margin-left:6px;font-size:11px;">目标回复</a-tag>
									<a-tag v-if="rp.pinStatus" color="#1890ff" style="margin-left:6px;font-size:11px;">置顶</a-tag>
									<a-tag v-if="rp.blackStatus" color="black" style="margin-left:6px;font-size:11px;">黑名单</a-tag>
									<a-tag v-if="rp.hiddenStatus" color="#faad14" style="margin-left:6px;font-size:11px;">屏蔽</a-tag>
								</div>
								<div style="font-size:13px;color:#333;margin-top:4px;padding-left:30px;"><span v-if="rp.targetName" >@{{rp.targetName}}：</span>{{rp.replyContent}}</div>
								<div v-if="rp.replyImgArr && rp.replyImgArr.length" v-viewer
									 style="display:flex;gap:6px;margin-top:4px;flex-wrap:wrap;padding-left:30px;">
									<img v-for="(rimg, rii) in rp.replyImgArr" :key="rii" :src="rimg"
										 style="width:60px;height:60px;object-fit:cover;border:1px solid #eee;cursor:pointer;" alt=""/>
								</div>
								<div style="display:flex;align-items:center;justify-content:space-between;margin-top:2px;padding-left:30px;">
									<div style="font-size:12px;color:#999;">{{rp.replyTime}}</div>
									<div style="display:flex;align-items:center;gap:8px;">
										<span style="cursor:pointer;color:#999;" ><a-icon type="like"/>{{(rp.likeNum || 0) + (rp.virtualLikeNum || 0)}}</span>
										<span style="cursor:pointer;color:#999;" ><a-icon type="message"/> {{rp.commentNum || 0}}</span>

									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div v-else style="text-align:center;padding:30px 0;color:#999;">暂无回复</div>
				<!-- 分页器 -->
				<a-pagination size="small"
							  :current="replyDetailPageInfo.current"
							  :total="replyDetailPageInfo.total"
							  :pageSize="replyDetailPageInfo.pageSize"
							  v-if="replyDetailPageInfo.total > 0"
							  @change="handleReplyDetailPageChange"
							  style="text-align:center;margin-top:12px;"/>
			</div>
		</a-modal>

	</div>
</template>

<script>
	import moment from 'moment'
	import {
		ossUpload
	} from "../../utils/oss";
	import {
		getReportDetailApi,
		operationLogApi,
		handleReportApi,
		getReplyTemplateListApi,
		sendReportEmailApi, getCommentDetailApi, getCommentSingleApi
	} from "../../api/index";

	export default {
		name: "ADDETAIL",
		data() {
			return {
				hhText:"",
				sendReporterLoading: false,
				sendTargetLoading: false,
				"factoryThumbnail": "/uploads/thumbnail/factory1.jpg",
				bannerUrl: "",
				form: this.$form.createForm(this),
				detailModel: {

				},
				currentComment: null, // 当前选中单条评价完整数据

				replyModal: false,
				tags1: [{
						tagId: 'VALID',
						tagName: "有效举报",
					},
					{
						tagId: 'MALICIOUS',
						tagName: "恶意举报",
					},
					{
						tagId: 'INVALID',
						tagName: "无效举报",
					},
					{
						tagId: 'PENDING',
						tagName: "待处理",
					}
				],
				tags2: [{
						tagId: 'PENDING',
						tagName: "待处理",
					},
					{
						tagId: 'PROCESSING',
						tagName: "处理中",
					},
					{
						tagId: 'RESOLVED',
						tagName: "已解决",
					},
					{
						tagId: 'CLOSED',
						tagName: "已关闭",
					}
				],
				commodityStatusList: [{
						label: "开启",
						value: true,
					},
					{
						label: "关闭",
						value: false,
					},
				],
				columns: [{
						title: "操作员",
						dataIndex: "operator",
						key: "operator",
					},
					{
						title: "操作",
						dataIndex: "operation",
						key: "operation",
					},
					{
						title: "时间",
						dataIndex: "operationTime",
						key: "operationTime",
					}
				],
				tableData: [],
				pageInfo: {
					pageSize: 20,
					current: 1,
					total: 0,
					showTotal: (total, range) => {
						return `合计 ${total} 条记录`;
					},
				},
				loading: false,
				reportId: null,
				hhData1:[],
				hhData2:[],
				innerType: undefined,
				radioStyle: {
					display: 'block',
					height: '30px',
					lineHeight: '30px',
				},
				replyList: [],
				replyDetailPageInfo: {
					current: 1,
					pageSize: 10,
					total: 0,
				},
				replyDetailList: [],

			};
		},
		computed: {
            isProcessed() {
                // 已处理：处理结果已选 或 举报状态为已解决/已关闭
                return !!(this.detailModel.handleResult) ||
                    this.detailModel.reportStatus === 'RESOLVED' ||
                    this.detailModel.reportStatus === 'CLOSED';
            }
        },
        methods: {
			hhChange1(e){
				const res=this.hhData1.filter(v=>v.templateId==e)[0].templateContent
				this.detailModel.msgToReporterContent=res
			},
			hhChange2(e){
				const res=this.hhData2.filter(v=>v.templateId==e)[0].templateContent
				this.detailModel.msgToTargetContent=res
			},
			onChange(e) {
				console.log('radio checked', e.target.value);
			},
			filterOption(input, option) {
				return (
					option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
				);
			},
			goBack() {this.$router.back();},
			innerTypechangeTabTop(e) {

			},
			send(val){
				if (val == 1) {
					this.sendReporterLoading = true;
				} else {
					this.sendTargetLoading = true;
				}
				let params = {
					"reportId": this.reportId,
					status:val,
					"content":val==1?this.detailModel.msgToReporterContent:this.detailModel.msgToTargetContent,
					"handleAction": this.detailModel.handleAction
				}
				sendReportEmailApi(params)
					.then((res) => {
						if (val == 1) {
							this.sendReporterLoading = false;
						} else {
							this.sendTargetLoading = false;
						}
						if (res.resultStatus) {
							// 本地更新发送状态，避免 getDetails 整体刷新覆盖未保存的屏蔽选择
							if (val == 1) {
								this.detailModel.isMsgToReporter = 'SENT';
							} else {
								this.detailModel.isMsgToTarget = 'SENT';
							}
							this.$message.success(
								'消息发送成功'
								// this.editModel.reportId ? "编辑成功" : "新增成功"
							);
							this.getData(this.pageInfo.current);

						} else {
							this.$message.error(res.errorMessage)

							console.log("res", res);
						}
					})
					.catch((error) => {
						if (val == 1) {
							this.sendReporterLoading = false;
						} else {
							this.sendTargetLoading = false;
						}
						console.log(error);
					})
					.finally(() => {})

			},
			sureEdit() {
				let params = {
					"handleAction": this.detailModel.handleAction,
					"reportStatus":this.detailModel.reportStatus,
					"handleResult": this.detailModel.handleResult,
					"msgToReporterContent":this.detailModel.msgToReporterContent,
					"msgToTargetContent": this.detailModel.msgToTargetContent,
					"handleRemark":this.detailModel.handleRemark,
					"reportId": this.reportId,
				}
				handleReportApi(params)
					.then((res) => {
						if (res.resultStatus) {
							this.getData(this.pageInfo.current);
							this.$message.success(
								'保存成功'
							);

						} else {
							this.$message.error(res.errorMessage)
							console.log("res", res);
						}
					})
					.catch((error) => {
						console.log(error);
					})
					.finally(() => {})
			},
			disabledDate(current) {
				return current && current < moment().subtract(1, 'days').endOf('day')
			},
			filterOption(input, option) {
				return (
					option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
				);
			},

			handleUpdataFile(e) {
				if (e.target.files.length) {
					if (e.target.files.length) {
						const file = e.target.files[0];
						if (file) {
							ossUpload(file, '', 'image/').then((res) => {

								this.form.setFieldsValue({
									bannerUrl: res.url
								});
								this.detailModel.bannerUrl = res.url;
							}).catch(err => {
								console.log("上传失败", err);
								this.$message.error('图片上传失败')
							});
						}
					}
				}
			},
			changePage(page) {
				this.pageInfo.current = page.current;
				this.getData(this.pageInfo.current);
			},

			getData(page = 1) {
				this.pageInfo.current = page;
				if (this.loading) {
					return;
				}
				this.loading = true;
				operationLogApi({
						pageNo: this.pageInfo.current,
						pageSize: this.pageInfo.pageSize,
						targetType: 'REPORT',
						userId:this.reportId
				})
					.then((res) => {
						if (res.resultStatus) {
							this.tableData = res.resultData.dataList || [];

							this.pageInfo.total = res.resultData.totalNum || 0;
							this.orderStaticsVO = res.resultData.userStatics
						} else {
							this.tableData = [];
							this.pageInfo.total = 0;
						}
					})
					.catch((err) => {
						console.error(err);
					})
					.finally(() => {
						this.loading = false;
					});
			},
			// here123
			getDetails() {
				this.$nextTick(() => {
					getReportDetailApi({
						reportId: this.reportId,
					}).then((res) => {
						if (res.resultStatus) {
							const result = res.resultData;
							this.detailModel = {
								  reportId: result.reportId,
								reportNo: result.reportNo ?? '',
								reporterUserName: result.reporterUserName ?? '',
								reportReason: result.reportReason ?? '',
								reportDesc: result.reportDesc ?? '',
								reportImages: result.reportImages ?? '',
								reportContent: result.reportContent ?? '',
								handleAction: result.handleAction ?? false,
								reportStatus: result.reportStatus ?? undefined,
								handleResult: result.handleResult ?? undefined,
								createTime: result.createTime ?? '',
								isMsgToReporter: result.isMsgToReporter ?? 'PENDING',
								isMsgToTarget: result.isMsgToTarget ?? 'PENDING',
								reporterTotalCount: result.reporterTotalCount ?? 0,
								reporterValidCount: result.reporterValidCount ?? 0,
								reporterMaliciousCount: result.reporterMaliciousCount ?? 0,
								reporterInvalidCount: result.reporterInvalidCount ?? 0,
								msgToReporterContent: result.msgToReporterContent ?? '',
								msgToTargetContent: result.msgToTargetContent ?? '',
								handleRemark: result.handleRemark ?? '',
								targetType: result.targetType ?? '',
								targetId: result.targetId,
								targetUserName:result.targetUserNameNew ?? '',
								reportContentIImage:result.reportContentIImage ?? null,
								commentId: result.commentId,
								parentTargetId: result.parentTargetId,
								userReplyId: result.userReplyId
							};
						} else {
							this.$message.warn(res.errorMessage);
							this.detailModel = {

							};
						}
					});

				})


			},
			getHh(val) {
				getReplyTemplateListApi({
						pageNo: 1,
						pageSize:1000,
						templateType: val,
						keywords: '',
						lang:'CH',
					})
					.then((res) => {
						if (res.resultStatus) {
							// 回复举报人
							if(val=='TO_REPORTER'){
								this.hhData1 = res.resultData.records || [];
							}
							// 回复被举报人
							if(val=='TO_TARGET'){
								this.hhData2 = res.resultData.records || [];
							}
							console.log(this.hhData1,'回复举报人')
							console.log(this.hhData1,'回复被举报人')
						} else {
							this.hhData = [];
						}
					})
					.catch((err) => {
						console.error(err);
					})
					.finally(() => {
						this.loading = false;
					});
			},

			// ========== 从举报详情打开评论查看弹窗 ==========
			openCommentDetail() {
				const commentId = this.detailModel.commentId;
				if (!commentId) return;
				this.currentComment = null;
				this.replyDetailList = [];
				this.replyDetailPageInfo = { current: 1, pageSize: 10, total: 0 };
				this.replyModal = true;
				this.loadReplyDetailPage(commentId);
			},
			// ========== 新增打开/关闭回复详情方法 ==========
			openReplyDetail(row) {
				this.currentComment = row;
				this.replyDetailPageInfo = { current: 1, pageSize: 10, total: 0 };
				this.replyDetailList = [];
				this.replyModal = true;
				this.loadReplyDetailPage(row.commentId);
			},
			loadReplyDetailPage(commentId) {
				if (!commentId && this.currentComment) {
					commentId = this.currentComment.commentId;
				}
				if (!commentId) return;
				getCommentDetailApi(commentId, {
					pageNo: this.replyDetailPageInfo.current,
					pageSize: this.replyDetailPageInfo.pageSize,
					parentTargetId:	this.detailModel.parentTargetId,
					userReplyId: this.detailModel.userReplyId
				}).then((res) => {
					if (res.resultStatus) {
						const resultData = res.resultData || {};
						let comment = resultData.comment
						if(comment){
							this.currentComment = comment
						}
	// currentComment 已由 openCommentDetail 通过 getCommentSingleApi 单独查询，此处不再回退
						this.replyDetailList = (resultData.dataList || []).map(rp => {
							let replyImgArr = [];
							if (rp.replyImages) {
								replyImgArr = rp.replyImages.split(/[,;]/).filter(url => url.trim());
							}
							const processedReplay = (rp.replay || []).filter(r => r).map(r => {
								let nestedImgArr = [];
								if (r.replyImages) {
									nestedImgArr = r.replyImages.split(/[,;]/).filter(url => url.trim());
								}
								return { ...r, replyImgArr: nestedImgArr };
							});
							return { ...rp, replyImgArr, replay: processedReplay };
						});
						// 标记目标回复：userReplyId 优先，为空则用 parentTargetId
						const targetKey = this.detailModel.userReplyId || this.detailModel.parentTargetId;
						if (targetKey) {
							this.replyDetailList = this.replyDetailList.map(rp => {
								const rpIsTarget = rp.replyId == targetKey;
								let processedReplay = rp.replay || [];
								if (processedReplay.length) {
									processedReplay = processedReplay.map(r => ({
										...r,
										isTargetReply: r.replyId == targetKey
									}));
								}
								return { ...rp, isTargetReply: rpIsTarget, replay: processedReplay };
							});
						}
						this.replyDetailPageInfo.total = resultData.totalNum || 0;
					} else {
						this.replyDetailList = [];
						this.replyDetailPageInfo.total = 0;
					}
				}).catch((err) => {
					console.error(err);
					this.replyDetailList = [];
				});
			},
			handleReplyDetailPageChange(page) {
				this.replyDetailPageInfo.current = page;
				if (this.currentComment) {
					this.loadReplyDetailPage(this.currentComment.commentId);
				}
			},

		},
		mounted() {
			const reportId = this.$route.params.id;
			this.reportId = reportId
			// 回复举报人
			this.getHh('TO_REPORTER')
			// 回复被举报人
			this.getHh('TO_TARGET')
			if (this.reportId) {
				this.getDetails(this.reportId)
			} else {
				this.form.setFieldsValue({
					bannerImageType: 'IMAGE'
				})
			}
			this.getData(1)

		},
		activated() {},
	};
</script>

<style lang="less" scoped>
	.titleCz {
		font-size: 18px;
		font-size: 18px;
		color: #333333;
		line-height: 18px;
		margin-top: 30px;
	}

	.container-top {
		padding: 20px;
		background-color: #fff;
		width: 700px;
		margin-left: 160px;

		/deep/ .ant-descriptions-item-label {
			width: 140px !important;
		}

		/* 右上角按钮 */
		.header {
			text-align: right;
			margin-bottom: 16px;
		}

		.title {
			font-size: 18px;
			color: #333333;
			line-height: 18px;
			// margin-bottom: 30px;
		}

		.titleCz {
			font-size: 18px;
			font-size: 18px;
			color: #333333;
			line-height: 18px;
			margin-bottom: 30px;
		}

		.ant-form-item {
			// margin-bottom: 0px !important;
		}
	}
</style>
